import { render, staticRenderFns } from "./ghService.vue?vue&type=template&id=341c2ccf&scoped=true"
import script from "./ghService.vue?vue&type=script&lang=js"
export * from "./ghService.vue?vue&type=script&lang=js"
import style0 from "./ghService.vue?vue&type=style&index=0&id=341c2ccf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341c2ccf",
  null
  
)

export default component.exports